import { CALL_API } from 'middleware/api';
import * as types from './types';
export const getLiveSheet = () => ({
    [CALL_API]: {
        endpoint: '/live-sheet',
        method: 'GET',
        types: [
            types.GET_LIVE_SHEET_REQUEST,
            types.GET_LIVE_SHEET_SUCCESS,
            types.GET_LIVE_SHEET_FAILURE,
        ],
    },
});
export const postLiveSheetEnable = () => ({
    [CALL_API]: {
        endpoint: '/live-sheet/enable',
        method: 'POST',
        types: [
            types.POST_LIVE_SHEET_ENABLE_REQUEST,
            types.POST_LIVE_SHEET_ENABLE_SUCCESS,
            types.POST_LIVE_SHEET_ENABLE_FAILURE,
        ],
        muteAlert: true,
    },
});
export const postLiveSheetDisable = () => ({
    [CALL_API]: {
        endpoint: '/live-sheet/disable',
        method: 'POST',
        types: [
            types.POST_LIVE_SHEET_DISABLE_REQUEST,
            types.POST_LIVE_SHEET_DISABLE_SUCCESS,
            types.POST_LIVE_SHEET_DISABLE_FAILURE,
        ],
    },
});
export const postLiveSheetSync = () => ({
    [CALL_API]: {
        endpoint: '/live-sheet/sync',
        method: 'POST',
        types: [
            types.POST_LIVE_SHEET_SYNC_REQUEST,
            types.POST_LIVE_SHEET_SYNC_SUCCESS,
            types.POST_LIVE_SHEET_SYNC_FAILURE,
        ],
    },
});
export const postLiveSheetGoogleOAuth2 = (redirectUri) => ({
    [CALL_API]: {
        endpoint: '/live-sheet/google-oauth2',
        method: 'POST',
        body: JSON.stringify({
            redirectUri: redirectUri.toString(),
        }),
        headers: { 'Content-Type': 'application/json' },
        types: [
            types.POST_GOOGLE_OAUTH2_REQUEST,
            types.POST_GOOGLE_OAUTH2_SUCCESS,
            types.POST_GOOGLE_OAUTH2_FAILURE,
        ],
    },
});
